import React from 'react';
import {
    FormControl,
    TextField,
    Typography
} from '@material-ui/core';
import {Autocomplete} from '@material-ui/lab';

//css
import StylesCss from './styles';
const useStyles = StylesCss();

export default ({
    escolhaFilial,
    opcoesFilial,
    handlerChangeEscolhaFilial,
    width
}) => {
    const classes = useStyles();

    const handlerOnChange = (event, newValue) => {
        if (newValue == null) return;
        handlerChangeEscolhaFilial(newValue);
    };
    
    return (
        <FormControl
            variant="outlined"
            className={classes.formControl}
            style={{width: (width!=null)?width:"60%"}}
        >
            <Typography className={classes.titlePopover}>
                Local de Entrega
            </Typography>
            <Autocomplete
                id="lb_id_filial"
                className={classes.autocomplete}
                options={opcoesFilial}
                getOptionLabel={o => o.name}
                value={escolhaFilial}
                onChange={handlerOnChange}
                loadingText={"Carregando..."}
                renderInput={params => (
                    <TextField
                        {...params}
                        variant={"standard"}
                        placeholder={"Filial"}
                        fullWidth
                    />
                )}
            />
        </FormControl>
    );
};
